import { useCallback, useMemo } from 'react';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';

const useShipFromApi = (apiCall, onSuccess, onError) => {
  const [loading, setLoading] = useAsyncSafeState(false);
  const [errors, setErrors] = useAsyncSafeState([]);

  const callShipFromApi = useCallback(
    async (newShipFrom) => {
      setErrors([]);
      setLoading(true);
      try {
        const result = await apiCall(newShipFrom);
        setLoading(false);
        onSuccess?.(result);
        return result;
      } catch (error) {
        setLoading(false);
        setErrors(error?.Errors || []);
        onError?.(error);
        throw error;
      }
    },
    [setLoading, setErrors, onError, onSuccess, apiCall],
  );

  return useMemo(
    () => ({
      callShipFromApi,
      loading,
      errors,
    }),
    [callShipFromApi, loading, errors],
  );
};

export default useShipFromApi;
